<template lang="pug">
.functions(id="function")
  h2 多样化的功能支持
  .container
    .function-item(v-for="func in functionData")
      .function-logo(:class="func.logo")
      .function-header {{ func.header }}
      p {{ func.content }}
</template>

<script>
export default {
  name: 'functions',
  data() {
    return {
      functionData: [
        {
          logo: 'cdn',
          header: '支持多家 CDN 服务商',
          content: '支持配置市面上所有热门 CDN 服务厂商'
        }, {
          logo: 'rate',
          header: '支持按比例配置',
          content: '可按任意比例配置调度，在各 CDN 厂商间进行负载均衡'
        }, {
          logo: 'route',
          header: '自定义线路',
          content: '支持各运营商、省份、海外灵活结合配置'
        }, {
          logo: 'strategy',
          header: '调度精准',
          content: '支持 EDNS，根据客户端 IP 进行调度解析，有效的防劫持'
        }, {
          logo: 'safety',
          header: '稳定安全',
          content: '支持海量并发访问，有效防护 DNS 的恶意攻击，保证域名服务正常'
        }, {
          logo: 'api',
          header: 'API',
          content: '强大开放的 API，让您的配置更加方便快捷'
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
h2
  text-align: center

.functions
  width: 1120px
  margin: 0 auto
  padding: 123px 0 103px

.container
  display: flex
  flex-wrap: wrap
  justify-content: space-between

.function-item
  width: 290px
  margin-top: 62px
  margin-bottom: 20px
  flex-shrink: 1
  text-align: center
  .function-logo
    height: 100px
    width: 100%
    margin-bottom: 20px
    background-repeat: no-repeat
    background-position: center
    &.cdn
      background-image: url('../assets/functions/CDN.svg')
    &.rate
      background-image: url('../assets/functions/rate.svg')
    &.route
      background-image: url('../assets/functions/route.svg')
    &.strategy
      background-image: url('../assets/functions/strategy.svg')
    &.safety
      background-image: url('../assets/functions/safety.svg')
    &.api
      background-image: url('../assets/functions/API.svg')
  .function-header
    line-height: 2.4em
    color: #333333
    font-size: 16px
  p
    line-height: 2.4em
    color: #666666
    font-size: 14px

</style>



// WEBPACK FOOTER //
// functions.vue?b0d76544